var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl, FormattedMessage, FormattedNumber, FormattedRelativeTime } from 'react-intl';
import classNames from 'classnames';
import { ApplicationContext } from '../../../ApplicationContext';
import { truncate } from "../../../utils/stringUtils";
import DateTime from '../../components/ui/DateTime/DateTime';
import Signals from '../../../signals/Signals';
import CloseServiceEntryOverlay from './CloseServiceEntryOverlay';
import UpdateServiceEntryOverlay from './UpdateServiceEntryOverlay';
import ServiceEntryViewOverlay from './ViewServiceEntryOverlay';
import ServiceEntryStatusComponent from './ServiceEntryStatusComponent';
import SetServiceEntryInProgressOverlay from './SetServiceEntryInProgressOverlay';
import SchemaTriggerIntervalValueType from '../../../data/SchemaTriggerIntervalValueType';
import Label from '../../components/ui/Label/Label';
import ServiceEntryPriorityComponent from './ServiceEntryPriorityComponent';
/**
 *
 */
var ServiceEntriesRow = /** @class */ (function (_super) {
    __extends(ServiceEntriesRow, _super);
    /**
     *
     */
    function ServiceEntriesRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onViewServiceEntry = _this.onViewServiceEntry.bind(_this);
        _this.onUpdateServiceEntry = _this.onUpdateServiceEntry.bind(_this);
        _this.onCloseServiceEntry = _this.onCloseServiceEntry.bind(_this);
        _this.onServiceEntryInProgress = _this.onServiceEntryInProgress.bind(_this);
        return _this;
    }
    /**
     *
     */
    ServiceEntriesRow.prototype.componentDidMount = function () {
        this.enrichModels();
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ServiceEntriesRow.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        this.enrichModels();
    };
    /**
     *
     * @returns {*}
     */
    ServiceEntriesRow.prototype.render = function () {
        var _a = this.props, serviceEntryModel = _a.serviceEntryModel, compact = _a.compact;
        var _b = this.context, assetCollection = _b.assetCollection, applicationModel = _b.applicationModel;
        var assetModel = assetCollection.list.find(function (asset) { return asset.getAssetSerial() === serviceEntryModel.assetId; });
        var classes = classNames({
            'service-entries-row': true,
            'service-entries-row--selected': applicationModel && assetModel ? applicationModel.selectedAsset === assetModel : false,
            "bg-white": true,
            "w-100": true,
            'mb-4': !compact,
            'mb-2': compact,
            "pl-3": true,
            "pr-3": true,
            'pt-4': !compact,
            'pb-4': !compact,
            'pt-2': compact,
            'pb-2': compact,
        });
        return (React.createElement("div", { style: { display: "contents" }, onClick: this.onViewServiceEntry, className: classes },
            React.createElement("div", { className: "text-nowrap" },
                React.createElement(ServiceEntryStatusComponent, { serviceEntryModel: serviceEntryModel })),
            React.createElement("div", { className: "text-nowrap" },
                React.createElement("div", { className: "btn-link cursor-pointer", onClick: function (event) {
                        event.stopPropagation();
                        if (!assetModel) {
                            return; //asset is archived for now no user feedback. See https://github.com/PVH-Mobile-Automation/PVH-CAT/issues/727
                        }
                        Signals.HideOverlay.dispatch();
                        Signals.ShowAssetDetail.dispatch(assetModel);
                    } }, assetModel ? assetModel.properties.displayedId : serviceEntryModel.assetEquipmentId)),
            React.createElement("div", { className: "text-nowrap" }, assetModel && assetModel.hasLocation ?
                React.createElement("a", { href: assetModel.googleMapsUrl, target: "_blank" },
                    React.createElement("div", { className: "d-flex justify-content-between w-100" },
                        assetModel.place,
                        React.createElement("i", { className: "ml-4 fe fe-external-link" }))) : '-'),
            React.createElement("div", { className: compact ? 'text-nowrap' : null }, assetModel ? assetModel.labels.map(function (labelModel, index) {
                return React.createElement(Label, { key: index + '-' + labelModel.id, model: labelModel, compact: compact });
            }) : ''),
            React.createElement("div", { className: "text-nowrap", title: serviceEntryModel.name }, truncate(serviceEntryModel.name, 24)),
            React.createElement("div", { className: "text-nowrap", title: serviceEntryModel.description }, truncate(serviceEntryModel.description)),
            React.createElement("div", { className: "text-nowrap" },
                React.createElement(ServiceEntryPriorityComponent, { serviceEntryModel: serviceEntryModel, compact: compact })),
            React.createElement("div", { className: "text-nowrap text-right" }, serviceEntryModel.originatingTriggerValue && assetModel ?
                (SchemaTriggerIntervalValueType.isPeriodial(serviceEntryModel.triggerIntervalValueType) ?
                    React.createElement("div", null,
                        React.createElement(FormattedRelativeTime, { value: (serviceEntryModel.originatingTriggerValue - Date.now()) / 1000, updateIntervalInSeconds: 60 })) :
                    React.createElement("div", null,
                        React.createElement(FormattedNumber, { value: serviceEntryModel.originatingTriggerValue - assetModel.cumulativeOperatingHoursDurationInHours, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 })))
                : '-'),
            React.createElement("div", { className: "text-nowrap text-right" },
                React.createElement(FormattedNumber, { value: assetModel && assetModel.cumulativeOperatingHoursDurationInHours, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 })),
            React.createElement("div", { className: "text-nowrap" }, serviceEntryModel.assignedTo),
            React.createElement("div", { className: "text-nowrap" }, serviceEntryModel.operatorName),
            React.createElement("div", { className: "text-nowrap" },
                React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.creationDateTimeUtc, hideTime: true, compact: compact })),
            React.createElement("div", { className: "text-nowrap" },
                React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.scheduledDateTimeUtc, hideTime: true, compact: compact })),
            React.createElement("div", { className: "text-nowrap" }, serviceEntryModel.dueDateTimeUtc &&
                React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.dueDateTimeUtc, hideTime: true, compact: compact })),
            React.createElement("div", { className: "text-nowrap d-flex justify-content-between", style: { right: 0 } },
                serviceEntryModel.canSetInProgress &&
                    React.createElement("div", { className: "text-nowrap mr-3" },
                        React.createElement("button", { className: "btn btn-sm btn-outline-warning ml-0 w-100", onClick: this.onServiceEntryInProgress, "data-id": serviceEntryModel.serviceEntryId },
                            React.createElement("i", { className: "fe fe-clipboard" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.service.entries.progress" }))),
                serviceEntryModel.canUpdate &&
                    React.createElement("div", { className: "text-nowrap mr-3" },
                        React.createElement("button", { className: 'btn btn-sm ml-0 w-100 btn-outline-' + (serviceEntryModel.scheduledDateTimeUtc ? 'primary' : 'warning'), onClick: this.onUpdateServiceEntry, "data-id": serviceEntryModel.serviceEntryId },
                            React.createElement("i", { className: "fe fe-edit-2" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.service.entries.edit" }))),
                serviceEntryModel.dueDateTimeUtc ?
                    React.createElement("div", { className: "text-nowrap mr-3" },
                        React.createElement("button", { className: "btn btn-sm ml-0 btn-outline-success w-100", onClick: this.onCloseServiceEntry, "data-id": serviceEntryModel.serviceEntryId },
                            React.createElement("i", { className: "fe fe-check" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.service.entries.close" }))) : React.createElement("div", null))));
    };
    /**
     *
     * @param event
     *
     */
    ServiceEntriesRow.prototype.onViewServiceEntry = function (event) {
        event.stopPropagation();
        var serviceEntryModel = this.props.serviceEntryModel;
        Signals.ShowOverlay.dispatch(React.createElement(ServiceEntryViewOverlay, { serviceEntryModel: serviceEntryModel }));
    };
    /**
     *
     */
    ServiceEntriesRow.prototype.onUpdateServiceEntry = function (event) {
        event.stopPropagation();
        var serviceEntryModel = this.props.serviceEntryModel;
        Signals.ShowOverlay.dispatch(React.createElement(UpdateServiceEntryOverlay, { serviceEntryModel: serviceEntryModel }));
    };
    /**
     *
     */
    ServiceEntriesRow.prototype.onCloseServiceEntry = function (event) {
        event.stopPropagation();
        var serviceEntryModel = this.props.serviceEntryModel;
        Signals.ShowOverlay.dispatch(React.createElement(CloseServiceEntryOverlay, { serviceEntryModel: serviceEntryModel }));
    };
    /**
     *
     * @param event
     */
    ServiceEntriesRow.prototype.onServiceEntryInProgress = function (event) {
        event.stopPropagation();
        var serviceEntryModel = this.props.serviceEntryModel;
        Signals.ShowOverlay.dispatch(React.createElement(SetServiceEntryInProgressOverlay, { serviceEntryModel: serviceEntryModel }));
    };
    /**
     *
     */
    ServiceEntriesRow.prototype.enrichModels = function () {
        // Enrich data of serviceEntryModel
        var serviceEntryModel = this.props.serviceEntryModel;
        var assetCollection = this.context.assetCollection;
        var assetModel = assetCollection.list.find(function (asset) { return asset.getAssetSerial() === serviceEntryModel.assetId; });
        if (assetModel) {
            serviceEntryModel.cumulativeOperatingHoursDurationInHours = assetModel.cumulativeOperatingHoursDurationInHours;
        }
    };
    ServiceEntriesRow = __decorate([
        observer
    ], ServiceEntriesRow);
    return ServiceEntriesRow;
}(React.Component));
ServiceEntriesRow.contextType = ApplicationContext;
export default injectIntl(ServiceEntriesRow);
